module.exports = "<div class=modal-header> <h4 class=modal-title>{{$ctrl.article.title}}</h4> </div> <div class=modal-body ng-bind-html=$ctrl.article.content></div> <div class=modal-footer> <button type=button class=\"btn btn-default\" ng-click=$ctrl.dismiss()>Закрыть</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/modules/important-notice/important-notice.html
// module id = d9aT
// module chunks = 1